import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

/**
 * @entity Comment
 */
@Entity()
export class Comment extends AdornisEntity {
  static override _class = 'Comment';

  @Field(type => ID) _id!: string;
  @Field(type => String) text: Maybe<string>;
  @Field(type => String) authorID: Maybe<string>;
  @Field(type => Date) createdAt: Maybe<Date>;
}
